import PusherJS from "pusher-js";
import store from "../store";
import tenant from "./tenant";
const ws = {
  wsClient: null,

  init(token = null) {
    if (token === null) {
      token = store.state.token;
    }
    if (this.wsClient === null) {
      this.wsClient = new PusherJS(tenant.getPusherKey(), {
        wsHost: tenant.getPusherDomain(),
        wsPort: process.env.VUE_APP_PUSHER_PORT,
        httpHost: tenant.getPusherHttpHost(),
        authEndpoint: tenant.getPusherAuthEndpoint(),
        forceTLS: process.env.VUE_APP_PUSHER_FORCETLS === "true",
        auth: {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
        encrypted: true,
        disableStats: true,
        enabledTransports: ["ws", "wss"],
      });
    } else {
      this.wsClient.config.auth.headers.Authorization = `Bearer ${token}`;
    }
  },

  subscribe(channel, event, resolve) {
    this.wsClient.subscribe(`private-${channel}`).bind(event, (e) => {
      resolve(e);
    });
  },
};

export default ws;
